import React, { Component } from 'react';
import {filterTags} from './filterTags.js';
import GroupThumbnail from 'components/mix/GroupThumbnail.js';
import OutputChannelChooser from './OutputChannelChooser.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import { Badge } from 'reactstrap';
import { connect } from "react-redux";
import {setSelectedGroup} from 'actions/index.js';
import {setSelectedTrack} from 'actions/index.js';

class Group extends Component {

    constructor(props) {
        super(props);
        this.state = {
            groups: props.groups
        };
        this.state = {volume: this.getVolume(), pattern: props.pattern};
    }

    get selectedTrack() {
        return this.props.sequencerEngine.tracks[this.props.selectedTrack];
    }

    isSelectedGroup() {
        return this.props.group.tracks.indexOf(this.selectedTrack) > -1 ||
            this.props.group === this.props.selectedGroup;
    }

    /**
     * returns the selected track within a group, if the selected track
     * is indeed found inside the given group. Otherwise, returns undefined
     */
    getSelectedTrackInGroup() {
        if (this.props.group.tracks.length == 1) {
            return this.props.group.tracks[0];
        } else if (this.props.group.tracks.indexOf(this.selectedTrack) > -1) {
            return this.selectedTrack;
        } else {
            return undefined;
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.pattern != nextProps.pattern) {
            this.state.pattern = nextProps.pattern;
            return true;
        }

        if (this.props.isSelected !== nextProps.isSelected ||
            this.props.group !== nextProps.group ||
            this.props.renders !== nextProps.renders ||
            this.props.trackDragging !== nextProps.trackDragging ||
            this.props.selectedTrack !== nextProps.selectedTrack ||
            this.state.selectedGroup !== nextProps.selectedGroup ||
            nextProps.volume != this.getVolume()) {
            return true;
        } 
        return false;
    }

    getVolume() {
        let selectedTrack = this.getSelectedTrackInGroup();
        if (this.props.group.tracks.length == 1) {
            return this.props.group.tracks[0].getVolume() - 15;
        } else if (selectedTrack === undefined ) {
            return this.props.group.volume;
        } else {
            return selectedTrack.getVolume() - 15;
        }
    }

    onSelectTrack(track) {
        if (track !== undefined) {
            this.props.cursor.track = track.trackNumber;
            this.props.sequencerEngine.selectTrack(track.trackNumber);
        } else {
            this.props.setSelectedTrack(undefined);
        }
        this.props.setSelectedGroup(this.props.group);
    }

    onChangeVolume(volume) {
        let selectedTrack = this.getSelectedTrackInGroup();
        if (this.props.group.tracks.length != 1 &&
            selectedTrack === undefined) {
            // change the volume of the entire group
            this.onSelectTrack(undefined);
            this.props.setSelectedGroup(this.props.group);
            this.props.group.setVolume(volume);
        } else {
            selectedTrack.setVolume(volume);
            this.onSelectTrack(selectedTrack);
        }
        this.setState({volume: volume});
    }

    getTags() {
        let tags = [];
        let selectedTrack = this.getSelectedTrackInGroup();
        if (selectedTrack === undefined ) {
            // show the groups tracks because a specific track is
            // not selected
            tags = []; // filterTags(this.props.group.tags);
        } else if (selectedTrack.sample !== undefined ) {
            // we have a selected track and it's not MIDI
            tags = filterTags(selectedTrack.sample.tags);
        } else {
            // other wise show the selected track's name (usually is gonna be MIDI)
            tags = [selectedTrack.getName()];
        }

        if (tags.length > 6) {
            tags.splice(0, 6);
        }
        return tags;
    }

    render() {
        return (
            <div
              className={this.isSelectedGroup() ? 'group selected with-tracks' : 'group with-tracks'}>
              <div className="volume-slider-container">
                <ReactBootstrapSlider
                  handle="square"
                  value={this.props.volume}
                  change={(e) => this.onChangeVolume(e.target.value)}
                  step={0.1}
                  max={6}
                  min={-40}
                  orientation="vertical"
                  reversed={true}
                  /> 
              </div>
                {!this.props.channelMixer.stereoConnected ? 
                  <OutputChannelChooser channel={this.props.group}/>
                  : ''}
              <GroupThumbnail
                onDraggingTrack={this.props.onDraggingTrack}
                trackDragging={this.props.trackDragging}
                renders={this.props.renders}
                groups={this.props.groups}
                onGroupsChanged={this.props.onGroupsChanged}
                isSelectedGroup={this.isSelectedGroup()}
                selectedTrack={this.props.selectedTrack}
                onSelectTrack={(track) => this.onSelectTrack(track)}
                group={this.props.group}/>
              <div className="tags-container">
                {this.getTags().map((tag) => <Badge size="sm" color="dark">{tag}</Badge>)}
              </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedTrack: track => dispatch(setSelectedTrack(track)),
        setSelectedGroup: group => dispatch(setSelectedGroup(group))
    }
};

const mapStateToProps = (state, props) => {
    let selectedTrackInGroup = undefined;
    let selectedTrack = props.sequencerEngine.tracks[state.mix.selectedTrack];
    if (props.group.tracks.length == 1) {
        selectedTrackInGroup = props.group.tracks[0].trackNumber;
    } else if (props.group.tracks.indexOf(selectedTrack) > -1) {
        selectedTrackInGroup = state.mix.selectedTrack;
    } 
    let volume = 0;
    if (props.group.tracks.length == 1) {
        volume = props.group.tracks[0].getVolume();
    } else if (selectedTrackInGroup === undefined ) {
        volume = state.tracks.groupVolumes[props.group.groupNumber];
    } else {
        volume = state.tracks.trackVolumes[selectedTrackInGroup];
    }
    
    return {
        volume: volume,
        selectedGroup: state.mix.selectedGroup,
        selectedTrack: state.mix.selectedTrack};
};

export default connect(mapStateToProps, mapDispatchToProps)(Group);
